<mat-form-field appearance="outline" class="searchable-multi-select" floatLabel="always" [class.field-error-state]="hasError()">
  <mat-label>{{ label() }} {{ getSelectedCountText() }}</mat-label>
  <mat-select
    [formControl]="selectControl"
    [panelClass]="panelClass()"
    [placeholder]="triggerText()"
    multiple
    (openedChange)="onPanelToggle($event)"
  >
    @if (triggerText()) {
      <mat-select-trigger>
        <span class="multi-select-trigger-placeholder">{{
          triggerText()
        }}</span>
      </mat-select-trigger>
    }

    <!-- Search input pinned at the top of the dropdown panel -->
    <div class="select-search-container" (click)="$event.stopPropagation()">
      <input
        class="select-search-input"
        type="text"
        [placeholder]="searchPlaceholder()"
        [(ngModel)]="searchTerm"
        (keydown)="$event.stopPropagation()"
      />
      @if (searchTerm) {
        <button
          class="select-search-clear"
          type="button"
          (click)="searchTerm = ''; $event.stopPropagation()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    @for (option of getFilteredOptions(); track option.value) {
      <mat-option [value]="option.value" [class.option-needs-coverage]="highlightedValues().includes(option.value)">{{ option.label }}</mat-option>
    }

    <!-- Hidden mat-options preserve selections that don't match the current search -->
    @for (option of getHiddenSelectedOptions(); track option.value) {
      <mat-option [value]="option.value" class="hidden-selected-option">{{
        option.label
      }}</mat-option>
    }

    @let emptyStateText = getEmptyStateText();
    @if (emptyStateText) {
      <!-- A disabled mat-option rather than a plain div: MatSelect._canOpen()
           requires at least one mat-option, so a field with no options would
           refuse to open the panel at all and this message could never be seen
           (the field just looked inert). Disabled keeps it unselectable and out
           of keyboard navigation, while still satisfying that check. -->
      <mat-option
        class="select-empty-state-option"
        [disabled]="true"
        role="status"
        >{{ emptyStateText }}</mat-option
      >
    }
  </mat-select>
</mat-form-field>
